module.exports = __webpack_public_path__ + "static/img/5-6.2f4587df.png";